<template>
  <div>
    <v-card>
      <v-card-text>
        <v-row>
          <v-col cols="11">
            <v-row dense>
              <v-col
                cols="12"
                md="3"
              >
                <v-select
                  v-model="form.user"
                  :disabled="view || form.all_kind_user"
                  :items="select.user"
                  label="Исполнитель"
                />
              </v-col>
              <v-col cols="3" v-if="!short">
                <v-checkbox
                  label="Все пользователи направления"
                  v-model="form.all_kind_user"
                  @change="all_kind_user_change"
                  />
              </v-col>
              <v-col
                cols="12"
                md="3"
              >
                <v-select
                  v-model="form.type"
                  :disabled="view"
                  :items="select.type"
                  label="Тип"
                />
              </v-col>
              <v-col
                cols="12"
                md="3"
              >
                <v-select
                  v-model="form.state"
                  :disabled="view"
                  :items="select.state"
                  label="Статус"
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
                v-if="!short"
              >
                <v-select
                  v-model="form.kind"
                  :disabled="view || form.insurance || form.contract"
                  :items="select.kind"
                  label="Направление деятельности"
                />
              </v-col>
              <v-col
                cols="12"
                md="3"
              >
                <v-text-field
                  v-model="form.phone"
                  :disabled="view"
                  label="Телефон"
                  required
                />
              </v-col>
              <v-col
                cols="12"
                md="3"
              >
                <v-text-field
                  v-model="form.email"
                  :disabled="view"
                  label="E-mail"
                  required
                />
              </v-col>
              <v-col cols="3">
                <v-text-field
                  v-model="form.theme"
                  :disabled="view"
                  label="Тема"
                  required
                />
              </v-col>
              <v-col cols="3">
                <v-text-field
                  v-model="form.date"
                  :disabled="view"
                  label="Дата"
                  type="date"
                  required
                />
              </v-col>
              <v-col cols="3">
                <v-text-field
                  v-model="form.time"
                  :disabled="view"
                  label="Время"
                  type="time"
                  required
                />
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="form.text"
                  :disabled="view"
                  label="Описание"
                  required
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="1">
            <v-row>
              <v-col cols="12">
                <v-icon large @click="$emit('close')">
                  mdi-close
                </v-icon>
              </v-col>
              <v-col cols="12">
                <v-icon large @click="event_save(false)" title="Сохранить изменения">
                  mdi-content-save
                </v-icon>
              </v-col>
              <v-col cols="12" class="mt-5">
                <v-icon large v-if="form.id && form.state == 1"
              :disabled="loader.show"
              color="error"
              title="Отменить задаие"
              @click="cancel_event">
                  mdi-calendar-remove
                </v-icon>
              </v-col>
              <v-col cols="12">
                <v-icon large v-if="form.id &&form.state == 1"
              :disabled="loader.show"
              color="primary"
              title="Завершить текущее и создать новое"
              @click="close_event(true)">
                  mdi-calendar-plus
                </v-icon>
              </v-col>
              <v-col cols="12">
                <v-icon large v-if="form.id &&form.state == 1"
              :disabled="loader.show"
              color="success"
              title="Завершить задание"
              @click="close_event(false)">
                  mdi-calendar-check
                </v-icon>
              </v-col>
              </v-row>
            </v-col>
          </v-row>           
      </v-card-text>
      <v-card-actions>
        <v-row>
          <v-col cols="6" class="text-left">
            <v-menu v-if="form.insurance && form.id">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="ml-5"
                  color="blue"
                  
                  v-bind="attrs"
                  v-on="on"
                ><v-icon>mdi-arrow-down-bold</v-icon>
                  <span class="mx-5">
                    <font color="white">
                      Действия со страховым полисом
                    </font>
                  </span>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="insurance_action(0)">
                  <v-list-item-title>Завершить, с пролонгацией полиса</v-list-item-title>
                </v-list-item>
                <v-list-item @click="insurance_action(1)">
                  <v-list-item-title>Завершить, продал ТС</v-list-item-title>
                </v-list-item>
                <v-list-item @click="insurance_action(2)">
                  <v-list-item-title>Завершить, отказ от страхования.</v-list-item-title>
                </v-list-item>
                <v-list-item @click="insurance_action(3)">
                  <v-list-item-title>Завершить, застрахован в другом месте.</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>           
          </v-col>
        </v-row>       
      </v-card-actions>
    </v-card>
    <v-dialog v-model="dialog.insurance.show" persistent>
      <InsuranceForm
        :create="dialog.insurance.create"
        :view="dialog.insurance.view"
        :change="dialog.insurance.change"
        :show="dialog.insurance.show"
        :vehicle="dialog.insurance.vehicle"
        :insurant="dialog.insurance.insurant"
        :data="dialog.insurance.data"
        :old="dialog.insurance.old"
        @close="insurance_close"
      />
    </v-dialog>
  </div>
</template>

<script>
  import $ from 'jquery'
  import moment from 'moment'
  export default {
    name: 'EventForm',
    props: ['create', 'view', 'change', 'data', 'show', 'short'],
    data () {
      return {
        dialog: {
          insurance: {
            show: false,
            view: false,
            change: false,
            create: true,
            data: {}
          }
        },
        loader: {
          show: false,
        },
        title: '',
        form: {
          id: '',
          theme: '',
          text: '',
          date: '',
          time: '',
          contract: '',
          accident: '',
          vehicle: '12:00',
          contract_item: {},
          accident_item: {},
          state: 0,
          type: 0,
          phone: '',
          email: '',
          client: '',
          client_item: {},
          user: '',
          user_item: {},
          insurance: '',
        },
        select: {
          kind: [
            {value: 0, text: 'Страхование'},
            {value: 1, text: 'Центр оформления ДТП'}
          ],
          state: [
            { value: 1, text: 'Новый' },
            { value: 2, text: 'Завершен' },
            { value: 3, text: 'Отменен' },
          ],
          type: [],
          user: [],
        },
      }
    },
    watch: {
      show: function () {
        if (this.show) {
          this.suggestion = false
          console.log(this.show, 'this.show')
          if (this.create) this.title = 'Создание'
          if (this.change) this.title = 'Изменение'
          if (this.view) this.title = 'Просмотр'
          this.load()
        }
      },
    },
    mounted: function () {
      for (let x in this.$store.state.dict.events) {
        this.select.type.push({
          value: Number(x),
          text: this.$store.state.dict.events[x].name,
        })
      }

      this.axios.post('/api/user/get/', {})
        .then(response => {
          if (!response.data.error) {
            for (let x in response.data.data) {
              this.select.user.push({
                value: response.data.data[x].id,
                text: response.data.data[x].surname + ' ' + response.data.data[x].name + ' ' + response.data.data[x].patronymic,
              })
            }
          } else {
            this.$store.commit('snackbar', response.data.data || 'Ошибка при получении данных')
          }
        })
        .catch(e => {
          this.$store.commit('snackbar', 'Ошибка при получении данных')
        })
      this.load()
    },
    methods: {
      all_kind_user_change: function() {
        if (this.form.all_kind_user) {
          this.form.user = ""
        }
      },
      insurance_close: function(data) {
        if (data && this.dialog.insurance.event) {
          this.form.text = "Клиент оформил полис " + data.doc.series + '/' + data.doc.number + '. Страхователь: ' + this.$store.state.dict.insurer[data.insurer].name
          this.form.state = 2
          this.event_save(false)
        }
        this.dialog.insurance.show = false
      },
      open_insurance: function(insurance) {
          this.dialog.insurance.data = insurance
          this.dialog.insurance.show = true
          this.dialog.insurance.old = null
          this.dialog.insurance.event = false
          this.dialog.insurance.create = false
          this.dialog.insurance.change = false
          this.dialog.insurance.view = true
      },
      insurance_action: function(type) {
        if (type === 0) {
          this.dialog.insurance.vehicle = this.form.insurance_item.vehicle
          this.dialog.insurance.show = true
          this.dialog.insurance.create = true
          this.dialog.insurance.change = false
          this.dialog.insurance.view = false
          this.dialog.insurance.old = this.form.insurance
          this.dialog.insurance.insurant = this.form.insurance_item.insurant
          this.dialog.insurance.event = true
          
        }
        if (type === 1) {
          this.form.insurance_item.state = 3
          this.$axios.post('/api/common/insurance/save/', this.form.insurance_item)
            .then(response => {
              if (!response.data.error) {
                this.form.text = "Клиент продал транспортное средство"
                this.form.state = 2
                this.event_save(false)
              } else {
                this.$store.commit('snackbar', response.data.data || 'Ошибка при сохранении данных')
              }
            })
            .catch(e => {
              console.log(e)
              this.$store.commit('snackbar', 'Ошибка при сохранении данных')
            })        
        }
        if (type === 2) {
          this.form.insurance_item.state = 4
          this.$axios.post('/api/common/insurance/save/', this.form.insurance_item)
            .then(response => {
              if (!response.data.error) {
                this.form.text = "Клиент отказался от страхования"
                this.form.state = 2
                this.event_save(false)
              } else {
                this.$store.commit('snackbar', response.data.data || 'Ошибка при сохранении данных')
              }
            })
            .catch(e => {
              console.log(e)
              this.$store.commit('snackbar', 'Ошибка при сохранении данных')
            })        
        }
        if (type === 3) {
          this.form.insurance_item.state = 5
          var insurance_settings = this.$store.state.settings.filter(a=>a.type == 'insurance')[0]
          let days = 350
          if (insurance_settings) {
            var days_settings = insurance_settings.data.filter(a=>a.key == 'days')[0]
            days = days_settings.value || 350
          }
          this.form.insurance_item.doc.date = moment(this.form.insurance_item.doc.date).add(days, 'days').format('YYYY-MM-DD')
          this.$axios.post('/api/common/insurance/save/', this.form.insurance_item)
            .then(response => {
              if (!response.data.error) {
                this.form.text = "Застрахован в другом месте"
                this.form.state = 2
                this.event_save(false)
              } else {
                this.$store.commit('snackbar', response.data.data || 'Ошибка при сохранении данных')
              }
            })
            .catch(e => {
              console.log(e)
              this.$store.commit('snackbar', 'Ошибка при сохранении данных')
            })        
        }
      },
      close_event: function(create_new) {
        this.form.state = 2
        this.event_save(create_new);
        /*if (create_new) {
          this.form = {
          id: '',
          theme: '',
          text: '',
          date: moment().format('YYYY-MM-DD'),
          time: '12:00',
          contract: this.form.contract,
          accident: this.form.accident,
          vehicle: this.form.vehicle,
          contract_item: this.form.contract_item,
          accident_item: this.form.accident,
          state: 0,
          type: 0,
          phone: '',
          email: '',
          client: this.form.client,
          client_item: this.form.client_item,
          user: this.form.user,
          user_item: this.form.user_item,
          insurance: this.form.insurance,
          insurance_item: this.form.insurance_item
        }
        if (this.form.client_item && this.form.client_item.phone && !this.form.phone) {
            this.form.phone =  this.form.client_item.phone
            }
          if (this.form.client_item && this.form.client_item.email && !this.form.email) {
            this.form.email =  this.form.client_item.email
            }
        this.create = true
        this.change = false       
        }*/
      },
      cancel_event: function() {
        this.form.state = 3
        this.event_save(false);
      },
      format_contract: function (number, date) {
        return number + '/' + moment(date).format('DDMM')
      },
      load: function () {
        if (this.data) {
          this.data.time = this.data.time || '12:00'
          this.form.id = this.data.id
          this.form.theme = this.data.theme
          this.form.text = this.data.text
          this.form.date = moment(this.data.date).format('YYYY-MM-DD')
          this.form.time = String(this.data.time).substring(0, 5)
          this.form.contract = this.data.contract
          this.form.contract_item = this.data.contract_item || {}
          this.form.accident = this.data.accident
          this.form.vehicle = this.data.vehicle
          this.form.accident_item = this.data.accident_item || {}
          this.form.state = this.data.state
          this.form.type = this.data.type
          this.form.phone = this.data.phone
          this.form.email = this.data.email
          this.form.client = this.data.client
          this.form.client_item = this.data.client_item || {}
          this.form.user = this.data.user
          this.form.user_item = this.data.user_item
          this.form.insurance = this.data.insurance
          this.form.insurance_item = this.data.insurance_item
          this.form.kind = this.data.kind
          this.form.all_kind_user = this.data.all_kind_user
          if (this.form.insurance) {
            this.form.kind = 0
          }
          if (this.form.contract) {
            this.form.kind = 1
          }
          if (this.form.client_item && this.form.client_item.phone && !this.form.phone) {
            this.form.phone =  this.form.client_item.phone
            }
          if (this.form.client_item && this.form.client_item.email && !this.form.email) {
            this.form.email =  this.form.client_item.email
            }
        } else {
          this.form = {
            id: '',
            theme: '',
            text: '',
            date: moment().format('YYYY-MM-DD'),
            time: '12:00',
            contract: '',
            accident: '',
            vehicle: '',
            contract_item: {},
            accident_item: {},
            state: 0,
            type: 0,
            phone: '',
            email: '',
            client: '',
            client_item: {},
            user: '',
            user_item: {},
          }
        }
        this.form.time = this.form.time || '12:00'
        this.form.date = this.form.date || moment()
        if (!this.form.id) {
          this.form.user = this.$store.state.user.id
          this.form.state = 1
          this.form.type = this.select.type.filter(a=>a.text == 'Звонок')[0].value
        }
      },
      event_save: function (stay) {
        this.form.time = this.form.time || '12:00'
        this.form.date = this.form.date || moment()
        if (!this.form.id) {
          this.$axios.post('/api/event/create/', this.form)
            .then(response => {
              if (!response.data.error) {
                this.$store.commit('snackbar', 'Успешно')
                this.$emit('close', response.data.data, true, stay)
              } else {
                this.$store.commit('snackbar', response.data.data || 'Ошибка при сохранении данных')
              }
            })
            .catch(e => {
              console.log(e)
              this.$store.commit('snackbar', 'Ошибка при сохранении данных')
            })
        } else {
          this.$axios.post('/api/event/save/', this.form)
            .then(response => {
              if (!response.data.error) {
                this.$store.commit('snackbar', 'Успешно')
                this.$emit('close', response.data.data, true, stay)
              } else {
                this.$store.commit('snackbar', response.data.data || 'Ошибка при сохранении данных')
              }
            })
            .catch(e => {
              console.log(e)
              this.$store.commit('snackbar', 'Ошибка при сохранении данных')
            })
        }
      },
    },
  }
</script>
